const ERROR_CODE = {
	can_not_disable_merchant: "can_not_disable_merchant"
};

export default ERROR_CODE;